import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import * as Icon from 'react-icons/fi';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import _ from 'underscore';

import useTable from 'ui/components/table';
import DetailLayout from './detail.layout';
import { Table, Customer } from 'services/action';
import tableConfig from './component/detail/pricing/table.config';
import { FormPricing } from 'ui/screens/authorized/_shared';
import { SkeletonTable } from 'ui/components/skeleton';

const initialState = {
  customer: null,
  data: null,
  showCreate: false,
  privilege: null,
};

const Action = ({ loading, data }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateTable = useSelector(
    (state) => state?.Table?.data['customer.pricing']
  );
  const [{ showCreate, privilege }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showCreate: false,
    }));
  };

  const $resetTable = async () => {
    $handleClose();
    Dispatch(Table.$reload('customer.pricing', StateTable));
  };

  const $getPrivilege = async () => {
    const payload = {};

    const pricing = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });

    if (pricing) {
      payload.pricing = pricing;
    }

    setState((prevState) => ({
      ...prevState,
      privilege: payload,
    }));
  };

  React.useEffect(() => {
    $getPrivilege();
  }, [Session]);

  if (loading) return null;

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id={`tooltip-top`}>Kembali</Tooltip>}
      >
        <Link to={`/master/customer`} className="btn btn-secondary px-2">
          <Icon.FiChevronsLeft size="17" />
        </Link>
      </OverlayTrigger>
      {(!Session?.privileges || privilege?.pricing?.action === 'manage') && (
        <button
          className="btn btn-primary py-1"
          onClick={() =>
            setState((prevState) => ({ ...prevState, showCreate: true }))
          }
        >
          <Icon.FiPlus color="white" size="14" />
          <span className="d-none d-md-block ms-2">Buat Harga Baru</span>
        </button>
      )}

      <Modal
        show={showCreate}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="lg"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah Harga</Modal.Title>
        </Modal.Header>
        <FormPricing
          onClose={$handleClose}
          onSuccess={$resetTable}
          customer_id={data?.id}
        />
      </Modal>
    </>
  );
};

const DetailPricing = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const [{ customer }, setState] = React.useState(initialState);
  const PricingTable = useTable('customer.pricing', tableConfig, false);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Customer.Show']
  );

  const $onLoad = async (id) => {
    const req = await Dispatch(Customer.$show(id));
    if (req?.message === 'success' && req?.data) {
      setState((prevState) => ({ ...prevState, customer: req?.data }));
    } else {
      History.push(`/master/customer`);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);

    const filters = {
      customer_id: match?.params?.id,
    };

    PricingTable.boot(filters);
  }, []);

  return (
    <DetailLayout
      customer_id={customer?.id}
      action={<Action handleUpdated={$onLoad} data={customer} />}
    >
      {StateLoading ? (
        <SkeletonTable headerCount={9} bodyCount={9} />
      ) : (
        <PricingTable.Render />
      )}
      <div className="p-3 border-top">
        <PricingTable.Pagination />
      </div>
    </DetailLayout>
  );
};

export default DetailPricing;
